import React, {
	type FunctionComponent,
	type PropsWithChildren,
	useCallback,
	useEffect,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import {
	Spotlight,
	SpotlightTransition,
	SpotlightManager,
	SpotlightTarget,
} from '@atlaskit/onboarding';
import { messages } from '../i18n';
import { useAnalytics } from '../../analytics';
import { InfiSpotlightAnalytics } from './InfiSpotlightAnalytics';

interface SpotlightWithScreenEventProps {
	dismissSpotlight: () => void;
}

const SpotlightWithScreenEvent: FunctionComponent<SpotlightWithScreenEventProps> = ({
	dismissSpotlight,
}) => {
	const intl = useIntl();
	const analytics = useAnalytics(InfiSpotlightAnalytics);

	useEffect(() => {
		analytics.spotlightViewed();
	}, [analytics]);

	const handleDismissButtonClick = useCallback(() => {
		analytics.spotlightDismissed();

		dismissSpotlight();
	}, [analytics, dismissSpotlight]);

	return (
		<Spotlight
			testId="testId-invite-people-infi-spotlight"
			dialogPlacement={'bottom center'}
			dialogWidth={354}
			actions={[
				{
					onClick: handleDismissButtonClick,
					text: intl.formatMessage(messages.infiSpotlightAction),
				},
			]}
			heading={intl.formatMessage(messages.infiSpotlightTitle)}
			target="coreInvitesThirdPartyConnectSpotlight"
			key="coreInvitesThirdPartyConnectSpotlight"
			targetRadius={3}
		>
			<FormattedMessage {...messages.infiSpotlightDescription} />
		</Spotlight>
	);
};

type InfiSpotlightProps = PropsWithChildren<{
	spotlightHidden: boolean;
	dismissSpotlight: () => void;
}>;

const InfiSpotlight = ({ children, spotlightHidden, dismissSpotlight }: InfiSpotlightProps) => (
	<SpotlightManager blanketIsTinted={false}>
		<SpotlightTarget name="coreInvitesThirdPartyConnectSpotlight">{children}</SpotlightTarget>
		<SpotlightTransition>
			{!spotlightHidden && <SpotlightWithScreenEvent dismissSpotlight={dismissSpotlight} />}
		</SpotlightTransition>
	</SpotlightManager>
);

export default InfiSpotlight;
